<template>
  <transition name="plann">
    <div v-show="show" id="floor_plann" class="floor-plann">
      <div id="floor" class="floor-plann-25">
        <div v-if="buildingString" class="floor-summary">
          <div>{{$t('view.building_number')}}: <strong>{{ buildingString.name }}</strong></div>
          <p v-for="(floor, index) in buildingString.floors" :key="index" :id="`floor-${buildingString.name}-${index}`">
            <span v-if="_.get(building, 'building.key') == floor._key">
              <strong class="color-warning">{{ floor.floor }}F. {{ floor.name }}</strong>
            </span>
            <span v-else>
              {{ floor.floor }}F. {{ floor.name }}
            </span>
          </p>
        </div>
      </div>

      <!-- 平面图 -->
      <svg id="lin" viewBox="50 -120 2200 2200" preserveAspectRatio="xMidYMin slice" xmlns="http://www.w3.org/2000/svg" @click="handleFloorPlannClick">
        <g id="boxpath"></g>
        <g id="boxSurface"></g>
        <g id="boxRoom"></g>
        <g id="boxwall"></g>
        <g id="boxcarpentry">
          <g id="direction" visibility="hidden" width="300" height="300" :transform="directionTransform">
            <image xlink:href="@/assets/direction.png" width="300" height="300"/>
          </g>
        </g>
        <g id="boxEnergy"></g>
        <g id="boxFurniture"></g>
        <g id="boxbind"></g>
        <g id="boxArea"></g>
        <g id="boxRib"></g>
        <g id="boxScale"></g>
        <g id="boxText"></g>
        <g id="boxDebug"></g>
      </svg>
      <div id="floor_plann_buttons">
        <a @click="handleFloorPlus"><i class="el-icon-circle-plus"/></a>
        <a @click="handleFloorMinus"><i class="el-icon-remove"/></a>
      </div>
    </div>
  </transition>
</template>

<script>
import $ from 'jquery';
import svgPanZoom from 'svg-pan-zoom';
import anime from 'animejs/lib/anime.es.js';

import SVG23d from '@/utils/SVG23d'
import loadFloorPlan from '@/utils/loadFloorPlan'

let svgPan = null;
let direction, floorPlanContainer, svgPanAnime;
let globalSVG = null;

export default {
  name: 'Floor',
  props: {
    currentScene: Object,
    currentPanorama: Object,
    buildings: Object,
    scenes: Array,
    display3D: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      building: null,
      object3D: null,

      directionTranslate: null,
      directionTransform: 'translate(1420,450) rotate(0) scale(1)',
      directionRotate: 0,
    }
  },
  destroyed() {
    this.undisplay();
  },
  computed: {
    buildingString() {
      return this._.find(this._.get(this.buildings, 'items'), building => {
        return this._.includes(this._.map(building.floors, '_key'), this._.get(this.currentScene, 'summary.building'));
      })
    },
    buildingPlans() {
      const plans = {
        default: this._.get(this.buildings, 'globalPlan.plan')
      };
      this._.each(this._.flatten(this._.map(this.buildings.items, 'floors'), 1), row => {
        plans[row._key] = row.plan;
      });
      return plans;
    }
  },
  watch: {
    directionTranslate() {
      this.setDirection()
    },
    directionRotate() {
      this.setDirection()
    },
    currentPanorama: {
      handler(panorama) {
        if (panorama) {
          this.$nextTick(() => {
            this.resetFloorFocus(true);
          })
        }
      },
      immediate: true
    },
    currentScene: {
      handler(scene) {
        const val = this._.get(scene, 'summary.building')
        if (this.object3D) {
          this.object3D.setFocus(val);
        }
        if (scene) {
          this.loadFloorPlan();
        }
      },
      immediate: true
    },
    display3D: {
      handler(value) {
        this.$nextTick(() => {
          if (value) {
            this.display();
          } else {
            this.undisplay();
          }
        })
      },
      immediate: true
    },

    buildings(value) {
      if (value) {
        this.init();
      }
    }
  },

  methods: {
    init() {
      direction = $('#direction');
      floorPlanContainer = $('#lin');
      svgPan = svgPanZoom(document.getElementById('lin'), {
        panEnabled: true,
        controlIconsEnabled: false,
        zoomEnabled: true,
        dblClickZoomEnabled: true,
        mouseWheelZoomEnabled: true,
        preventMouseEventsDefault: true,
        zoomScaleSensitivity: 0.2,
        minZoom: 0.8,
        maxZoom: 5,
        fit: true,
        contain: true,
        center: true,
        refreshRate: 'auto',
        beforeZoom: function(){},
        onZoom: (zoom) => {},
        beforePan: () => {},
        onPan: () => {},
        onUpdatedCTM: () => {},
      });
      svgPan.zoom(1.6);
    },
    handleFloorPlus() {
      svgPan.zoomIn()
    },
    handleFloorMinus() {
      svgPan.zoomOut()
    },

    handleFloorPlannClick(event) {
      const value = $(event.target).data('value');
      if (value) {
        this.$emit('input', { panorama: value });
      }
    },

    // 加载平面图
    loadFloorPlan() {
      const key = this._.get(this.currentScene, 'summary.building') || 'default';
      const plan = this._.get(this.buildingPlans, key) || this._.get(this.buildingPlans, 'default');
      loadFloorPlan.loadFromData(plan);
      this.handleFloorCenter();
    },

    display() {
      this.object3D = new SVG23d(document.getElementById('floor'), {
        callback: data => {
          this.$emit('input', data)
          this.building = data
        },
        buildings: this._.map(this.buildings.items, item => {
          const floors = this._.map(item.floors, floor => {
            const key = this._.get(floor, '_key')
            return {
              key: key,
              has: !!this._.find(this.scenes, scene => this._.get(scene, 'summary.building') == key),
              floor: floor.floor
            } 
          })
          let floorNumber = this._.size(floors)
          if (this._.get(item, 'floorNumber')) {
            floorNumber = item.floorNumber
          }
          return { floors, floorNumber: floorNumber, name: item.name }
        })
      })
      if (!globalSVG) {
        globalSVG = this.object3D.loadSVGFromElement($('#lin'))
      } else {
        this.object3D.loadSVG(globalSVG, true)
      }
    },

    undisplay() {
      if (this.object3D) {
        this.object3D.destroy()
        this.object3D = null
      }
    },

    resetFloorFocus() {
      $('#lin .focus-link').removeClass('focus-link')
      $('#lin .focus-room').removeClass('focus-room')

      const room = $(`#lin *[data-${this.currentScene.uid}="1"]`)
      room.addClass('focus-room')
      
      const point = $(`#lin *[data-value="${this.currentPanorama.uid}"]`)
      point.addClass('focus-link')

      // 切换平面图焦点
      this.handleFloorCenter(true)

      const parentTransform = point.parent().attr('transform')

      if (parentTransform) {
        direction.attr('visibility', 'visible')
        const matches = parentTransform.match(/translate\((-?[0-9.]*)\D?(-?[0-9.]*)\)/) 
        this.directionTranslate = matches ? `${matches[1]-150} ${matches[2]-300}` : null
      } else {
        direction.attr('visibility', 'hidden')
        direction.attr('transform', 'scale(0, 0)')
      }
    },

    setDirectionRotate(rotate) {
      this.directionRotate = rotate;
    },

    setDirection() {
      this.directionTransform = (this.directionTranslate && this.directionRotate !== undefined)
        ? `translate(${this.directionTranslate}) rotate(${this.directionRotate}) scale(1)` : '';
    },

    // 平面图居中
    handleFloorCenter(isSame) {
      const viewport = document.querySelector('#boxwall');
      const viewportRect = viewport.getBoundingClientRect();
      
      if (isSame) {
        if (viewportRect.width > floorPlanContainer.width()) {
          const size = svgPan.getSizes();
          const parentTransform = $('#lin .focus-link').parent().attr('transform');
          if (parentTransform) {
            const matches = parentTransform.match(/translate\(([0-9.]*)\D?([0-9.]*)\)/);
            if (matches && this._.isNumber(parseFloat(matches[1])) && this._.isNumber(parseFloat(matches[2]))) {
              this.svgPanAnime({
                x: -matches[1] * size.realZoom + size.width / 2,
                y: svgPan.getPan().y,
              });
            }
          }
        }
      } else {
        const containerPosition = floorPlanContainer.position();
        const pan = svgPan.getPan();
        svgPan.pan({
          x: pan.x + containerPosition.left + (floorPlanContainer.width() - viewportRect.width) / 2 - viewportRect.x,
          y: pan.y + containerPosition.top + (floorPlanContainer.height() - viewportRect.height) / 2 - viewportRect.y,
        });
      }
    },

    svgPanAnime(pan) {
      const old = this._.cloneDeep(svgPan.getPan())
      if (svgPanAnime) {
        svgPanAnime && svgPanAnime.remove()
      }
      svgPanAnime = anime.timeline({
        easing: "easeInOutSine",
        changeComplete: () => {},
        complete: anim => {
          svgPanAnime && svgPanAnime.remove()
        }
      })
      svgPanAnime.add({
        duration: 150,
        update: e => {
          svgPan.pan({
            x: (pan.x - old.x) * e.progress / 100 + old.x,
            y: (pan.y - old.y) * e.progress / 100 + old.y,
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.plann-enter-active, .plann-leave-active {
  transition: all .2s;
}
.plann-enter, .plann-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>